import styled from 'styled-components'

export const HomeStyled = styled.div`
  border:0;
  padding:0;
  margin:0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .open{
    display: flex;
    flex-direction: column;
    width: 100%;
}
`
